export const LIMIT_REACHED_MESSAGE =
  "You reached your daily limit for messaging new people.";

export const INVITE_MESSAGE_MATCHERS = [
  "Please complete the interview at your earliest convenience",
  "Please schedule a time that works best for you by using the link below.",
];
